import React, { useState, useEffect } from 'react';
import { Dropdown, Checkbox } from 'semantic-ui-react';
import { UpdateDocumentsCashflowAreaId } from 'src/graphql/documents';
import { AgendaByName, UpdateAgenda } from 'src/graphql/agenda';
import CashflowAreaDropdown from 'src/components/general/js/formTypes/cashflowAreaDropdown';
import { importUpdateCashflowNeeded } from 'src/redux/actions/flujocaja';
import { importAlertState } from 'src/redux/actions/alert';
import { useDispatch } from 'react-redux';
import CustomModal from '../../configuracion/components/customModal';

export const EditAreaModal = ({ companyId, option, selected }) => {

  const dispatch = useDispatch();

  const [updateAgendaChecked, setUpdateAgendaChecked] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [selectedCashflowAreaId, setSelectedCashflowAreaId] = useState();

  const issuerName = selected[0]?.meta?.issuerName;
  const shouldPauseQuery = !open || !issuerName || !companyId;
  const agendaData = AgendaByName(issuerName, companyId, shouldPauseQuery);
  const newAgendaData = agendaData?.data?.AgendaByName;
  const updateAgenda = UpdateAgenda();

  const updateDocumentsCashflowAreaId = UpdateDocumentsCashflowAreaId();

  useEffect(() => {
    if (open && updateAgendaChecked && !newAgendaData && issuerName && companyId && agendaData?.reexecuteQuery) {
      agendaData.reexecuteQuery({ requestPolicy: 'network-only' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, updateAgendaChecked, newAgendaData]);

  const handleSubmit = async () => {



    try {

      const input = {
        documentsIds: selected.map((document) => document.id),
        cashflowAreaId: selectedCashflowAreaId,
        companyId
      }

      const { data, error } = await updateDocumentsCashflowAreaId.executeMutation({ input })

      if (updateAgendaChecked) {
        await updateAgenda.executeMutation({
          id: newAgendaData?.id,
          input: {
            name: newAgendaData?.name,
            rut: newAgendaData?.rut,
            defaultCashflowAreaProvider: selectedCashflowAreaId,
            isClient: newAgendaData?.isClient,
            isProvider: newAgendaData?.isProvider
          }
        })
      }
      handleClose();

      if (error || data?.modifyDocument?.nModified === 0) {
        return dispatch(
          importAlertState({
            content: "Error al cambiar el área del documento, intente nuevamente.",
            state: "error",
            duration: 3,
          })
        )
      }

      dispatch(importUpdateCashflowNeeded({ value: true, reload: null }))

      dispatch(
        importAlertState({
          content: "Documento modificado con éxito",
          state: "success",
          duration: 3,
        })
      )

    } catch (error) {
      console.error(error);
    }
  };

  const onChange = (value) => {
    setSelectedCashflowAreaId(value);
  };

  let cantidadDoc = selected.length

  return (
    <>
      <Dropdown.Item value={option?.value} onClick={handleOpen}>
        {option?.text}
      </Dropdown.Item>
      <CustomModal
        open={open}
        onClose={handleClose}
        dimmer="blurring"
        size="small"
        closeOnDimmerClick={false}
        classNameModal="edit-documento-modal"
        title="Editar Documento"
        cancelarLabel="Cerrar"
        confirmLabel="Aplicar Cambios"
        onConfirm={handleSubmit}
        content={
        <div className="tw-w-full tw-flex tw-flex-col tw-gap-4">
          <div className="tw-mb-2">
            <h5 className='fw-bold tw-text-base'>{`${cantidadDoc} ${cantidadDoc > 1 ? "Documentos seleccionados" : "Documento seleccionado"}.`}</h5>
            <p className="tw-mt-2 tw-text-[15px] tw-leading-snug tw-text-gray-700">{`Seleccione los cambios que quiere hacer ${cantidadDoc > 1 ? "a los Documentos" : "al Documento"}.`}</p>
          </div>
          <div className="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
          <label className='fw-normal tw-text-sm tw-text-gray-800' style={{ marginBottom: '8px', display: 'block' }}>Área</label>
          <CashflowAreaDropdown
            onChange={onChange}
          />
          <Checkbox
            label="Quiero asignar esta área a todos los documentos del proveedor"
            checked={updateAgendaChecked}
            onChange={() => setUpdateAgendaChecked(!updateAgendaChecked)}
            style={{ marginTop: '24px' }}
            disabled={cantidadDoc > 1 ? true : false}
          />
          </div>
        </div>
        }
      />
    </>
  );
};
